import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  "login-register": defineAsyncComponent(() => import("/vercel/path0/layouts/login-register.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/vercel/path0/layouts/login.vue").then(m => m.default || m)),
  mobile: defineAsyncComponent(() => import("/vercel/path0/layouts/mobile.vue").then(m => m.default || m)),
  settings: defineAsyncComponent(() => import("/vercel/path0/layouts/settings.vue").then(m => m.default || m)),
  todo: defineAsyncComponent(() => import("/vercel/path0/layouts/todo.vue").then(m => m.default || m))
}